import { styled } from 'styled-components';

export const StyledContentWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
